/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import type {
  CreateTransmittalRecord,
  PagedResultOfTransmittalRecordSummaryDto,
  ReceiveTransmittalRecord,
  ReleaseTransmittalRecord,
  SaveTransmittalRecord,
  SearchTransmittalRecordsParams,
  TransmittalRecordDto
} from '../models';

import { customInstance } from '../axios';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * @summary Returns a paged list of transmittalrecords matching the supplied filter and sort criteria.
 */
export const searchTransmittalRecords = (
    params?: SearchTransmittalRecordsParams,
 options?: SecondParameter<typeof customInstance<PagedResultOfTransmittalRecordSummaryDto>>,) => {
      return customInstance<PagedResultOfTransmittalRecordSummaryDto>(
      {url: `/transmittal/transmittal-records`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Creates a new TransmittalRecord from the supplied command.
 */
export const createTransmittalRecord = (
    createTransmittalRecord: CreateTransmittalRecord,
 options?: SecondParameter<typeof customInstance<TransmittalRecordDto>>,) => {
      return customInstance<TransmittalRecordDto>(
      {url: `/transmittal/transmittal-records`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createTransmittalRecord
    },
      options);
    }
  /**
 * @summary Returns the TransmittalRecord identified by the route id.
 */
export const getTransmittalRecordById = (
    id: string,
 options?: SecondParameter<typeof customInstance<TransmittalRecordDto>>,) => {
      return customInstance<TransmittalRecordDto>(
      {url: `/transmittal/transmittal-records/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Saves the TransmittalRecord identified by the route id with the supplied command.
 */
export const saveTransmittalRecord = (
    id: string,
    saveTransmittalRecord: SaveTransmittalRecord,
 options?: SecondParameter<typeof customInstance<TransmittalRecordDto>>,) => {
      return customInstance<TransmittalRecordDto>(
      {url: `/transmittal/transmittal-records/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: saveTransmittalRecord
    },
      options);
    }
  /**
 * @summary Marks the TransmittalRecord identified by the route id as released.
 */
export const releaseTransmittalRecord = (
    id: string,
    releaseTransmittalRecord: ReleaseTransmittalRecord,
 options?: SecondParameter<typeof customInstance<TransmittalRecordDto>>,) => {
      return customInstance<TransmittalRecordDto>(
      {url: `/transmittal/transmittal-records/${id}/release`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: releaseTransmittalRecord
    },
      options);
    }
  /**
 * @summary Marks the TransmittalRecord identified by the route id as received.
 */
export const receiveTransmittalRecord = (
    id: string,
    receiveTransmittalRecord: ReceiveTransmittalRecord,
 options?: SecondParameter<typeof customInstance<TransmittalRecordDto>>,) => {
      return customInstance<TransmittalRecordDto>(
      {url: `/transmittal/transmittal-records/${id}/receive`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: receiveTransmittalRecord
    },
      options);
    }
  /**
 * @summary Cancels the TransmittalRecord identified by the route id.
 */
export const cancelTransmittalRecord = (
    id: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/transmittal/transmittal-records/${id}/cancel`, method: 'DELETE'
    },
      options);
    }
  export type SearchTransmittalRecordsResult = NonNullable<Awaited<ReturnType<typeof searchTransmittalRecords>>>
export type CreateTransmittalRecordResult = NonNullable<Awaited<ReturnType<typeof createTransmittalRecord>>>
export type GetTransmittalRecordByIdResult = NonNullable<Awaited<ReturnType<typeof getTransmittalRecordById>>>
export type SaveTransmittalRecordResult = NonNullable<Awaited<ReturnType<typeof saveTransmittalRecord>>>
export type ReleaseTransmittalRecordResult = NonNullable<Awaited<ReturnType<typeof releaseTransmittalRecord>>>
export type ReceiveTransmittalRecordResult = NonNullable<Awaited<ReturnType<typeof receiveTransmittalRecord>>>
export type CancelTransmittalRecordResult = NonNullable<Awaited<ReturnType<typeof cancelTransmittalRecord>>>
